export default "__VITE_ASSET__a237227a__"